export const SET_OPPORTUNITY_DATA = "SET_OPPORTUNITY_DATA";
export const SET_OPPORTUNITY_SORT_ORDER = "SET_OPPORTUNITY_SORT_ORDER";
export const SET_OPPORTUNITY_RESET_SORT = "SET_OPPORTUNITY_RESET_SORT";
export const RESET_COMMON_ERROR_VALIDATOR = "RESET_COMMON_ERROR_VALIDATOR";

const initialState = {
  opportunities_page: 1,
  opportunities_perpage: 20,
  isopportunitiesLoading: false,
  total_opportunities: 0,
  opportunities_list: [],
  opportunities_list_refetch_force: false,
  opportunities_list_refetch: false,
  partner_filter_options: [],
  selectedPartner: null,

  isActivityChecked: false,
  isArchivedChecked: false,

  confirm_opportunity_popup: false,
  disable_confirm_btn: false,
  opportunityData: {},
  confirmType: "",
  completeOpportunityList: [],
  completeOpportunityListOpen: false,
  countries: [],
  country_id: "",
  region_name: "",
  parentOrgList: [],
  parentOrgListLoading: false,
  selectedParentOrgKey: [],
  opp_search: "",
  statusFilter: [],
  sort: {
    booking_date: "DESC",
    deal_id: "ASC",
    cr_party_name: "ASC",
    track: "ASC",
    max_est_incentive_amount: "ASC",
    sub_track: "ASC",
    ws_deal_id: "ASC",
  },
  allcxPlanIds: [],
  disabledDownload: false,
  archiveArray: [],
  nextArchiveConfirmPopup: false,
  bulkArchiveItems: [],
  nextBtnDisable: false,
  nextActivityConfirmPopup: false,
  nextActivityContent: "",
  nextActivityBtnDisable: false,
  dataInNewDeals: [],
  existActivityData: [],
  actHint: true,
  archiveData: [],
  dealExtraNotes: "",
  extraNotePopup: false,
  activeNoteItems: [],
  noteBtnDisable: false,
  isLoadingModal: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_OPPORTUNITY_DATA:
      return { ...state, ...action.payload };
    case SET_OPPORTUNITY_SORT_ORDER:
      return {
        ...state,
        sort: Object.keys(state.sort).reduce((newSort, key) => {
          newSort[key] =
            key === action.payload.column ? action.payload.newSortOrder : "";
          return newSort;
        }, {}),
      };
    case RESET_COMMON_ERROR_VALIDATOR:
      return {
        ...state,
        commonErrorValidator: {},
      };
    default:
      return state;
  }
};
